import { render } from "./DocumentClassTableColumnsSubView.vue?vue&type=template&id=abe4d6fe&ts=true"
import script from "./DocumentClassTableColumnsSubView.vue?vue&type=script&lang=ts"
export * from "./DocumentClassTableColumnsSubView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__